var _classCallCheck = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var Document =
/*#__PURE__*/
function () {
  "use strict";

  function Document() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Document);

    this.url = url;
    this.title = title;
    this.description = description;
    this.content = content;
  }

  return Document;
}();

var Link =
/*#__PURE__*/
function () {
  "use strict";

  function Link(url, method) {
    var encoding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';
    var fields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var title = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var description = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

    _classCallCheck(this, Link);

    if (url === undefined) {
      throw new Error('url argument is required');
    }

    if (method === undefined) {
      throw new Error('method argument is required');
    }

    this.url = url;
    this.method = method;
    this.encoding = encoding;
    this.fields = fields;
    this.title = title;
    this.description = description;
  }

  return Link;
}();

var Field =
/*#__PURE__*/
function () {
  "use strict";

  function Field(name) {
    var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    _classCallCheck(this, Field);

    if (name === undefined) {
      throw new Error('name argument is required');
    }

    this.name = name;
    this.required = required;
    this.location = location;
    this.description = description;
  }

  return Field;
}();

module.exports = {
  Document: Document,
  Link: Link,
  Field: Field
};